module.exports = __webpack_public_path__ + "img/wareflare.55bf7b3e.svg";